import { Injectable } from '@angular/core';
import { FilterModel } from 'src/app/shared/models/common-model';
import { CommonService } from 'src/app/shared/services/common.service';
@Injectable({
  providedIn: 'root'
})
export class DBQDoctorService {
  getAllURL = 'DBQDoctor/all-doctors';
  getAllDoctorSpecialityURL = 'DBQDoctor/all-doctor-speciality';
  getAllSpecialisedDoctorsForAppontmentURL = 'DBQDoctor/apppointment-all-doctors';
  getByIdURL = "DBQDoctor/doctor-by-id";
  createURL = "DBQDoctor/create-doctor";
  updateURL = "DBQDoctor/doctor-update";
  deleteURL = "DBQDoctor/doctor-delete";

  getDBQDoctorSettingByIdURL = "DBQDoctor/dbq-doctor-setting-by-id";
  createDBQDoctorSettingURL = "DBQDoctor/create-dbq-doctor-setting";
  updateDBQDoctorSettingURL = "DBQDoctor/dbq-doctor-setting-update";


  getDBQDoctorAvailabilityURL = "DBQDoctor/dbq-doctor-availabilty-by-id";
  createDBQDoctorAvailabilityURL = "DBQDoctor/create-dbq-doctor-availabilty";
  updateDBQDoctorAvailabilityURL = "DBQDoctor/dbq-doctor-availabilty-update";
  deleteDBQDoctorAvailabilityURL = "DBQDoctor/dbq-doctor-availabilty-delete";


  getAllDoctorAppontmentsURL = 'DBQDoctor/all-doctor-appointment';
  getDoctorAppontmentByIdURL = "DBQDoctor/doctor-appointment-by-id";
  getDoctorAppontmentByPaientInviteIdURL = "DBQDoctor/doctor-appointment-by-patient-invite-id";
  getDoctorSessionsURL = "DBQDoctor/doctor-session-duration";
  createDoctorAppontmentURL = "DBQDoctor/create-doctor-appointment";
  updateDoctorAppontmentStatusURL = "DBQDoctor/doctor-appointment-status-update";
  rescheduleDoctorAppointmentURL = "DBQDoctor/doctor-appointment-reschedule";




  constructor(private commonService: CommonService) { }

  getById(id: number, offset: number) {
    return this.commonService.getById(this.getByIdURL + "?Id=" + id + "&offSet=" + offset, {});
  }

  getDBQDoctorSettingById(id: number) {
    return this.commonService.getById(this.getDBQDoctorSettingByIdURL + "?Id=" + id, {});
  }

  getDBQDoctorAvailabilityById(id: number) {
    return this.commonService.getById(this.getDBQDoctorAvailabilityURL + "?Id=" + id, {});
  }

  getDBQDoctorAppointmentById(id: number) {
    return this.commonService.getById(this.getDoctorAppontmentByIdURL + "?Id=" + id, {});
  }

  getDBQDoctorAppointmentByPatientInviteId(id: number) {
    return this.commonService.getById(this.getDoctorAppontmentByPaientInviteIdURL + "?Id=" + id, {});
  }

  getDBQDoctorSessions(sessionDuration: number, dbqDoctorId: number, startDate: string, offset: number) {
    return this.commonService.getById(this.getDoctorSessionsURL + "?sessionDuration=" + sessionDuration + "&dbqDoctorId=" + dbqDoctorId + "&startDate=" + startDate + "&offSet=" + offset, {});
  }

  save(userModel: any) {
    return this.commonService.post(this.createURL, userModel);
  }
  saveDBQDoctorSetting(userModel: any) {
    return this.commonService.post(this.createDBQDoctorSettingURL, userModel);
  }

  saveDBQDoctorAvailability(userModel: any) {
    return this.commonService.post(this.createDBQDoctorAvailabilityURL, userModel);
  }

  saveDBQDoctorAppointment(userModel: any) {
    return this.commonService.post(this.createDoctorAppontmentURL, userModel);
  }

  update(userModel: any) {
    return this.commonService.put(this.updateURL, userModel);
  }

  updateDBQDoctorSetting(userModel: any) {
    return this.commonService.put(this.updateDBQDoctorSettingURL, userModel);
  }
  updateDBQDoctorAvailability(userModel: any) {
    return this.commonService.put(this.updateDBQDoctorAvailabilityURL, userModel);
  }
  updateDoctorAppointmentStatus(userModel: any) {
    return this.commonService.put(this.updateDoctorAppontmentStatusURL, userModel);
  }
  rescheduleDoctorAppointment(userModel: any) {
    return this.commonService.put(this.rescheduleDoctorAppointmentURL, userModel);
  }

  delete(id: number) {
    return this.commonService.delete(`${this.deleteURL}?id=${id}`, {})
  }

  deleteDBQDoctorAvailabilityById(id: number) {
    return this.commonService.delete(`${this.deleteDBQDoctorAvailabilityURL}?id=${id}`, {})
  }

  getAll(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType, filterModal.hospitalId, filterModal.statusIds, filterModal.doctorIds, filterModal.dateFrom, filterModal.dateTo, filterModal.isActiveShift, filterModal.hospitalUserId, filterModal.dbqPatientId, filterModal.doctorSpecialityId, filterModal.isDoctorLogin, filterModal.statusApp, filterModal.statusTypeApp);
  }

  getAllSpecialisedDbqDoctor(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllSpecialisedDoctorsForAppontmentURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType, filterModal.hospitalId, filterModal.statusIds, filterModal.doctorIds, filterModal.dateFrom, filterModal.dateTo, filterModal.isActiveShift, filterModal.hospitalUserId, filterModal.dbqPatientId, filterModal.doctorSpecialityId);
  }

  getAllDoctorAppontments(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllDoctorAppontmentsURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType, filterModal.hospitalId, filterModal.statusIds, filterModal.doctorIds, filterModal.dateFrom, filterModal.dateTo, filterModal.isActiveShift, filterModal.hospitalUserId, filterModal.dbqPatientId, filterModal.doctorSpecialityId);
  }
  getAllDoctorSpecialities() {
    return this.commonService.getAll(this.getAllDoctorSpecialityURL);
  }
}
